export enum FormEnums {
  CARE_ASSESSMENT = "nurse-care-assessment",
  DAILY_REPORTING = "daily-reporting",
  RESIDENT_STATE_REPORTING = "resident-state-reporting",
  FLUID_INTAKE_OUTPUT_REPORT = "fluid-intake-output-report",
  VITAL_SIGNS = "vital-signs",
  BOWEL_MOVEMENT = "bowel-movement",
  ACCIDENTS_INCIDENTS = "accidents-incidents",
  BARTHEL_SCORE = "barthel-index",
  REPORTS = "reports",
  MEDICAL_NOTES = "medical-notes",
  RESIDENT_BODY_MAP = "resident-body-map",
  ADMISSION_CHECKLIST = "admission-checklist",
  RESIDENT_PORTFOLIO = "resident-portfolio",
  MUST = "must",
  MMSE = "mmse",
  BRADEN_SCALE = "braden-scale",
  FRASE = "frase",
}

export enum FluidIntakeEnums {
  ORAL = "oral",
  INTRAVENOUS = "intravenous",
  GASTRIC = "gastric",
  PEG = "peg",
  OTHER = "other",
}

export const NewFormButtonText = {
  [FormEnums.CARE_ASSESSMENT]: "New Care Plan",
  [FormEnums.DAILY_REPORTING]: "New Report",
  [FormEnums.RESIDENT_STATE_REPORTING]: "New State Report",
  [FormEnums.FLUID_INTAKE_OUTPUT_REPORT]: "Log Fluid Output",
  [FormEnums.VITAL_SIGNS]: "New Parameters Report",
  [FormEnums.BOWEL_MOVEMENT]: "Log New Bowel Movement",
  [FormEnums.ACCIDENTS_INCIDENTS]: "Log Accident or Incident",
  [FormEnums.BARTHEL_SCORE]: "Log Barthel Score",
  [FormEnums.REPORTS]: "Generate Report",
  [FormEnums.MEDICAL_NOTES]: "New Medical Note",
  [FormEnums.ADMISSION_CHECKLIST]: "Create Admission Checklist",
  [FormEnums.RESIDENT_PORTFOLIO]: "Create Resident Portfolio",
  [FormEnums.MUST]: "Log MUST Assessment",
  [FormEnums.MMSE]: "Log MMSE Assessment",
  [FormEnums.BRADEN_SCALE]: "Log Braden Scale Assessment",
  [FormEnums.FRASE]: "Log FRASE Assessment",
};

export const FormTagTitles = {
  [FormEnums.CARE_ASSESSMENT]: "Care Assessment",
  [FormEnums.DAILY_REPORTING]: "Daily Reporting",
  [FormEnums.RESIDENT_STATE_REPORTING]: "Resident State Reporting",
  [FormEnums.VITAL_SIGNS]: "Parameters",
  [FormEnums.BOWEL_MOVEMENT]: "Bowel Movement",
  [FormEnums.ACCIDENTS_INCIDENTS]: "Accidents Incidents",
  [FormEnums.BARTHEL_SCORE]: "Barthel Score",
  [FormEnums.MEDICAL_NOTES]: "Medical Notes",
  [FormEnums.ADMISSION_CHECKLIST]: "Admission Checklist",
  [FormEnums.RESIDENT_PORTFOLIO]: "Resident Portfolio",
  [FormEnums.MUST]: "Malnutrition Universal Screening Tool",
  [FormEnums.MMSE]: "Mini-Mental State Examination",
  [FormEnums.BRADEN_SCALE]: "Braden Scale",
  [FormEnums.FRASE]: "Fall Risk Assessment Tool",
};
export const FormTagTypes = [
  {
    value: FormEnums.CARE_ASSESSMENT,
    label: FormTagTitles[FormEnums.CARE_ASSESSMENT],
  },
  {
    value: FormEnums.DAILY_REPORTING,
    label: FormTagTitles[FormEnums.DAILY_REPORTING],
  },
  {
    value: FormEnums.RESIDENT_STATE_REPORTING,
    label: FormTagTitles[FormEnums.RESIDENT_STATE_REPORTING],
  },
  { value: FormEnums.VITAL_SIGNS, label: FormTagTitles[FormEnums.VITAL_SIGNS] },
  {
    value: FormEnums.ACCIDENTS_INCIDENTS,
    label: FormTagTitles[FormEnums.ACCIDENTS_INCIDENTS],
  },
  {
    value: FormEnums.BARTHEL_SCORE,
    label: FormTagTitles[FormEnums.BARTHEL_SCORE],
  },
  {
    value: FormEnums.MEDICAL_NOTES,
    label: FormTagTitles[FormEnums.MEDICAL_NOTES],
  },
  {
    value: FormEnums.ADMISSION_CHECKLIST,
    label: FormTagTitles[FormEnums.ADMISSION_CHECKLIST],
  },
  {
    value: FormEnums.RESIDENT_PORTFOLIO,
    label: FormTagTitles[FormEnums.RESIDENT_PORTFOLIO],
  },
  { value: FormEnums.MUST, label: FormTagTitles[FormEnums.MUST] },
  { value: FormEnums.MMSE, label: FormTagTitles[FormEnums.MMSE] },
  {
    value: FormEnums.BRADEN_SCALE,
    label: FormTagTitles[FormEnums.BRADEN_SCALE],
  },
  { value: FormEnums.FRASE, label: FormTagTitles[FormEnums.FRASE] },
];

export const FormTagDescription = {
  [FormEnums.CARE_ASSESSMENT]:
    "Assessment used in the Resident Care Plan. (Only first assessment is used)",
  [FormEnums.DAILY_REPORTING]:
    "Assessments used in the Resident Daily Reporting. (Multiple assessments will be shown)",
  [FormEnums.RESIDENT_STATE_REPORTING]:
    "Assessments used in the Resident State Reporting. (Single assessment will be shown)",
  [FormEnums.VITAL_SIGNS]:
    "Assessments used in the Resident Parameters. (Single assessment will be shown)",
  [FormEnums.BOWEL_MOVEMENT]:
    "Assessments used in the Resident Bowel Movement. (Single assessment will be shown)",
  [FormEnums.ACCIDENTS_INCIDENTS]:
    "Assessments used in the Resident Accidents and Incidents Reporting. (Single assessment will be shown)",
  [FormEnums.BARTHEL_SCORE]:
    "Assessments used in the Resident Barthel Score. (Single assessment will be shown)",
  [FormEnums.MEDICAL_NOTES]:
    "Assessments used in the Resident Medical Notes. (Multiple assessments will be shown)",
  [FormEnums.ADMISSION_CHECKLIST]:
    "Assessments used in the Resident Admission Checklist. (Single assessment will be shown)",
  [FormEnums.MUST]:
    "Assessments used in the Resident Malnutrition Universal Screening Tool. (Single assessment will be shown)",
  [FormEnums.MMSE]:
    "Assessments used in the Resident Mini-Mental State Examination. (Single assessment will be shown)",
  [FormEnums.BRADEN_SCALE]:
    "Assessments used in the Resident Braden Scale. (Single assessment will be shown)",
  [FormEnums.FRASE]:
    "Assessments used in the Resident Fall Risk Assessment Tool. (Single assessment will be shown)",
};

export const ExportableForms = [
  FormEnums.ADMISSION_CHECKLIST,
  FormEnums.RESIDENT_PORTFOLIO,
];
